import type { TAdditionalInfoVariations } from '@alfa-bank/site-dc-form-api/src/models';

import type { IDesktopText, IMobileText } from '../../models';

export const getPassportText = ({
    additionalInfoVariations,
    text,
}: {
    additionalInfoVariations: TAdditionalInfoVariations;
    text: IMobileText | IDesktopText;
}) => {
    return additionalInfoVariations === 'childrenBrokerage'
        ? text.brokerageConfig?.passportRequiredForChildrenBrokerage ??
              'Понадобится паспорт, свидетельство\u00A0о\u00A0рождении и\u00A0паспорт\u00A0родителя'
        : text.passportRequired;
};
